// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"f0168907","565":"e7e0460b"}[chunkId] + ".chunk.js";
};